

// import React from "react";
// import { IoMdAdd } from "react-icons/io";
// import { BASE_URL } from "../../constant/api";
// const ProductImage = ({
//   product_images,
//   handleImageChange,
//   handleSubmit,
//   newProduct,
// }) => {
//   // const product_imagesToShow = product_images.slice(-3);

//   return (
//     <div className="mt-5 flex h-full w-full flex-col gap-2 lg:mt-0">
//       <h3 className="text-brand-text-light">Add Product Images</h3>
//       <div className="md:flex md:w-[33rem] h-[33rem] md:h-auto grid grid-cols-2 overflow-y-scroll w-full items-center gap-4 md:overflow-x-auto bg-slate-100">
//         {product_images.map((img, index) => (
//           <div
//             key={index}
//             className="flex h-36 w-36 md:flex-shrink-0 items-center justify-center"
//           >
//             {img instanceof File ? (
//               <img
//                 src={URL.createObjectURL(img)}
//                 alt={`Product image ${index}`}
//                 className="h-3/4 w-3/4 object-cover"
//               />
//             ) : (
//               <img
//                 src={`${BASE_URL}${img.image}`}
//                 alt={`Product image ${index}`}
//                 className="h-3/4 w-3/4 object-cover"
//               />
//             )}
//           </div>
//         ))}
//         <div className="flex h-36 w-36 flex-shrink-0 items-center justify-center">
//           <input
//             id="imageUpload"
//             type="file"
//             multiple
//             onChange={handleImageChange}
//             className="hidden"
//           />
//           <label
//             htmlFor="imageUpload"
//             className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-full bg-white"
//           >
//             <IoMdAdd className="h-full w-full text-brand-text-light" />
//           </label>
//         </div>
//       </div>

//       {newProduct && (
//         <button
//           type="submit"
//           className="mt-4 w-full rounded bg-[#05BF02] px-6 py-2 text-white hover:bg-[#189b16]"
//           onClick={handleSubmit}
//         >
//           Publish
//         </button>
//       )}
//     </div>
//   );
// };

// export default ProductImage;

import React from "react";
import { IoMdAdd } from "react-icons/io";
import { MdDelete } from "react-icons/md";
import { BASE_URL } from "../../constant/api";

const ProductImage = ({ product_images, handleImageChange, handleSubmit, newProduct, handleRemoveImage ,productId }) => {

  return (
    <div className="mt-5 flex h-full w-full flex-col gap-2 lg:mt-0">
      <h3 className="text-brand-text-light">Add Product Images</h3>
      <div className="md:flex md:w-[33rem] h-[33rem] md:h-auto grid grid-cols-2 overflow-y-scroll w-full items-center gap-4 md:overflow-x-auto bg-slate-100">
        {product_images.map((img, index) => (
          <div key={index} className="relative flex h-36 w-36 md:flex-shrink-0 items-center justify-center">
            {img instanceof File ? (
              <img src={URL.createObjectURL(img)} alt={`Product image ${index}`} className="h-3/4 w-3/4 object-cover" />
            ) : (
              <img src={`${BASE_URL}${img.image}`} alt={`Product image ${index}`} className="h-3/4 w-3/4 object-cover" />
            )}
            {/* Remove button */}
            <button
              onClick={() => handleRemoveImage(index,productId,img.id)}
              className="absolute top-1 right-1 bg-red-500 text-white p-2 rounded-md"
            >
              X
            </button>
          </div>
        ))}
        {/* Add image button */}
        <div className="flex h-36 w-36 flex-shrink-0 items-center justify-center">
          <input id="imageUpload" type="file" multiple onChange={handleImageChange} className="hidden" />
          <label htmlFor="imageUpload" className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-full bg-white">
            <IoMdAdd className="h-full w-full text-brand-text-light" />
          </label>
        </div>
      </div>

      {newProduct && (
        <button type="submit" className="mt-4 w-full rounded bg-[#05BF02] px-6 py-2 text-white hover:bg-[#189b16]" onClick={handleSubmit}>
          Publish
        </button>
      )}
    </div>
  );
};

export default ProductImage;
